import * as React from "react";
import { formatMessage } from "lib/globalize-util";
import { Label, Dropdown } from "@nuorder/components";
import { FOLDERS } from "constants/integration/folders";
import { AssortmentTemplate } from "containers/folders/types/base";
import { useAssortmentDialogContext, ActionsTypes, DropdownOption } from "./context";

const templateOptions = (): DropdownOption[] =>
    Object.keys(AssortmentTemplate).map((template) => ({
        id: AssortmentTemplate[template],
        key: AssortmentTemplate[template],
        text: formatMessage(AssortmentTemplate[template]),
    }));

export const CloseoutAssortmentDropdown = () => {
    const { dispatch, formValues, isEditing } = useAssortmentDialogContext();

    const onChangeAssortmentTemplate = (value: AssortmentTemplate) => {
        dispatch({ type: ActionsTypes.UPDATE_ASSORTMENT_TEMPLATE, payload: value });
    };
    return (
        <>
            <Label>{formatMessage("Assortment Template")}</Label>
            <Dropdown
                testId={FOLDERS.CREATE_ASSORTMENT_DIALOG.ASSORTMENT_TEMPLATE_DROPDOWN}
                selectedKey={formValues.assortmentTemplate}
                options={templateOptions()}
                onChange={onChangeAssortmentTemplate}
                disabled={isEditing}
            />
        </>
    );
};
